import { createSlice } from "@reduxjs/toolkit";
import { sendGeneralRequest } from "../generalRequest";

const initialState = {
  shouldDisplaySingleInvoice: false,
  shouldDisplayMainUtilityView: true,
  isTransactionSuccessfullyCompleted: false,
  isTransactionSuccessfullyStarted: false,
  isConfirmationDialogOpen: false,
  extraData: [],
  transactionId: "",
  singleInvoice: {},
  isLoading: false,
  success: '',
  message:'',
  confirmData:[],
  isAlbania:''
};

export const digitalbSlice = createSlice({
  name: "digitalb",
  initialState,
  reducers: {
    displaySingleInvoice: (state) => {
      state.shouldDisplaySingleInvoice = true;
      state.shouldDisplayMainUtilityView = false;
    },
    displayMainUtilityView: (state) => {
      state.shouldDisplaySingleInvoice = false;
      state.shouldDisplayMainUtilityView = true;
    },
    setIsTransactionSuccessfullyCompleted: (state, action) => {
      state.isTransactionSuccessfullyCompleted = action.payload;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setIsAlbania: (state, action) => {
      state.isAlbania = action.payload;
    },
    setIsTransactionSuccessfullyStarted: (state, action) => {
      state.isTransactionSuccessfullyStarted = action.payload;
    },
    changeConfirmationDialogState: (state) => {
      state.isConfirmationDialogOpen = !state.isConfirmationDialogOpen;
    },
    resetDigitalbSlice: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendGeneralRequest.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(sendGeneralRequest.rejected, (state) => {
        state.isLoading = false;
      })
      .addCase(sendGeneralRequest.fulfilled, (state, action) => {
        state.isLoading = false;
        if (
          action.payload.endpoint === "DGA/GetProducts"
        ) {
          state.extraData = action.payload.response.products
        }else if (
          action.payload.endpoint === "DGA/GetProductsOTT"
        ) {
          state.extraData = action.payload.response.products
          state.isAlbania = action.payload.response.success
        } else if (
          action.payload.endpoint === "DGA/StartTransaction" ||
          action.payload.endpoint === "DGA/StartTransactionOTT"
        ) {
          state.isTransactionSuccessfullyStarted = true;
          state.singleInvoice = {
            Vlera: action.payload.response.defaultPrice + " Leke",
            Komisioni: action.payload.response.fee + " Leke",
            Zbritja: action.payload.response.offerPrice + " Leke",
            Totali: action.payload.response.finalPrice + " Leke",
          };
          state.transactionId = action.payload.response.transID;
          state.shouldDisplaySingleInvoice = true;
          state.shouldDisplayMainUtilityView = false;
        } else if (
          action.payload.endpoint === "DGA/ConfirmTransaction" ||
          action.payload.endpoint === "DGA/ConfirmTransactionOTT"
        ) {
          state.isTransactionSuccessfullyCompleted = true;
          state.shouldDisplayMainUtilityView = true;
        }else if(action.payload.endpoint === "DGA/StartOTTActivation"){
          state.success = action.payload.response.success;
          state.message = action.payload.response.errorMsg
        }else if(action.payload.endpoint === "DGA/ConfirmOTTActivation"){
          state.confirmData = {success: action.payload.response.success, message: action.payload.response.errorMsg};
        }
      });
  },
});
export const {
  displaySingleInvoice,
  displayMainUtilityView,
  resetDigitalbSlice,
  changeConfirmationDialogState,
  setIsTransactionSuccessfullyStarted,
  setIsTransactionSuccessfullyCompleted,
  setMessage,
  setSuccess,
  setIsAlbania
} = digitalbSlice.actions;

export const selectDigitalbState = (state) => state.digitalb;

export default digitalbSlice.reducer;
